module.exports = __webpack_public_path__ + "static/media/logout.261fc68a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/logout.svg
// module id = 399
// module chunks = 0